import { sumRegex } from '../utils/regex'

export const isSumValid = (sum) =>
  !sum ||
  !sum.match(sumRegex) ||
  parseFloat(sum) <= 0 ||
  isNaN(parseFloat(sum)) ||
  (sum.startsWith('0') && sum.length > 1 && sum.charAt(1) !== '.') ||
  sum.endsWith('.')
